import Router from 'next/router';
import React from 'react';

function flatten(text, child) {
  return typeof child === 'string'
    ? text + child
    : React.Children.toArray(child.props.children).reduce(flatten, text);
}

function handleHeadingClick(id, href) {
  if (href) {
    Router.push(`${href}#${id}`);
  } else {
    const cleanAspath = Router.asPath.split('?')[0].split('#')[0];
    Router.push(Router.pathname, `${cleanAspath}#${id}`);
  }
}

const HeadingRenderer = ({ level, children: propChildren, baseHref }) => {
  const children = React.Children.toArray(propChildren);
  const text = children.reduce(flatten, '');
  const slug = text.toLowerCase().replace(/\W/g, '-');
  const id = slug.endsWith('-') ? slug.slice(0, -1) : slug;
  return React.createElement(
    `h${level}`,
    {
      className: 'cursor-pointer relative',
      onClick: () => handleHeadingClick(id, baseHref),
    },
    <>
      <span id={id} style={{ position: 'absolute', top: '-100px' }} />
      {children}
    </>,
  );
};

export default HeadingRenderer;
